<template>
  <div>
    <v-skeleton-loader
      class="mx-auto ml-2 mr-2"
      type="table"
      :loading="loading"
    >
      <!-- <v-container fluid class="mb-4"> -->
      <!-- <CommunityInfo
        :communityInfo="communityInfo"
        @onRelatedCommunityChanged="showRelatedCommunity"
      /> -->
      <div
        class="d-flex align-items-center justify-content-space-between flex-wrap flex-sm-nowrap my-2 "
      >
        <div
          class="d-flex align-items-center justify-space-between flex-wrap mr-1"
        >
          <span class="font-weight-bolder font-size-h3 uppercase">
            {{ tt[activeLang]["myCustomers"] }}
            <!-- My customers -->
          </span>
          <!-- <v-divider class="mx-5" vertical></v-divider>
          <v-select
            v-model="quickFindCustomerId"
            :items="quickFindCustomers"
            :loading="isQuickFindCustomersLoading"
            item-text="communityName"
            item-value="aspireId"
            :label="tt.getTranslatedText(activeLang, 'customerQuickFind')"
          >
          </v-select> -->
        </div>
      </div>
      <div>
        <v-data-table
          :headers="headers"
          :items="customers"
          item-key="id"
          :loading="isLoading"
          :server-items-length="totalCustomers"
          :options.sync="options"
          loading-text="Loading... Please wait"
          class="customers-table styled-table elevation-1"
        >
          <template #[`item.sentiment`]="{ item }">
            <router-link :to="`/customers/${item.aspireId}`">
              <span
                :class="[
                  item.sentiment >= 4 && 'text-orange',
                  item.sentiment < 4 && 'text-blue'
                ]"
                >{{ item.sentiment }}</span
              >
              <!-- <img
                v-if="item.isActive && item.sentiment.value < 4"
                key="sentiment_less_4"
                width="17px"
                height="20px"
                src="media/assets/orange-leaf.png"
              /> -->
            </router-link>
          </template>
          <template #[`item.kudos`]="{ item }">
            <img
              v-if="item.kudos > 0"
              key="has_kudos_icon"
              width="25px"
              height="30px"
              src="/media/assets/icons/icons_kudos_orange.png"
              class="mx-4"
            />
          </template>
          <template #[`item.communityName`]="{ item }">
            <router-link :to="`/customers/${item.aspireId}`" class="blue-color">
              {{ item.communityName }}
            </router-link>
          </template>
          <template #[`item.serviceRequestsActions`]="{ item }">
            <router-link :to="`/customers/${item.aspireId}/requests`">
              <button
                class="mx-2 btn white-color my-2"
                :class="[
                  item.openRequests > 0 && 'background-color-orange',
                  item.openRequests == 0 && 'background-color-grey'
                ]"
              >
                {{ tt[activeLang]["serviceRequests"] }}
                <!-- Service Requests -->
              </button>
            </router-link>
          </template>
          <template #[`item.orangeReportActions`]="{ item }">
            <router-link :to="`/customers/${item.aspireId}/orange-reports/new`">
              <img
                key="action_item_add_new_orange_report my-2"
                width="25px"
                height="30px"
                src="/media/assets/icons/icons_new_orange_report.png"
                class="mx-4"
              />
            </router-link>
            <router-link :to="`/customers/${item.aspireId}/orange-reports`">
              <img
                key="action_item_past_orange_reports my-2"
                width="25px"
                height="30px"
                src="/media/assets/icons/icons_past_orange_reports.png"
                class="mx-4"
              />
            </router-link>
          </template>
        </v-data-table>
      </div>
      <!-- </v-container> -->
    </v-skeleton-loader>
  </div>
</template>

<style lang="scss">
.customers-table.styled-table {
  tr:nth-child(even) {
    background-color: rgba(223, 101, 38, 0.18);
  }
  tr:nth-child(odd) {
    background-color: rgba(223, 101, 38, 0.07);
  }
  td {
    background-color: rgba(223, 101, 38, 0.07);
  }
}
.uppercase {
  text-transform: uppercase;
}
.sentiment-header {
  background-image: url("/media/assets/icons/icons_yn_sentiment_header_white.png");
  background-position: center center;
  background-repeat: no-repeat;
  background-size: 20px;

  span {
    display: none;
  }
}

.kudos-header {
  background-image: url("/media/assets/icons/icons_yn_kudos_header_white.png");
  background-position: center center;
  background-repeat: no-repeat;
  background-size: 30px;

  span {
    display: none;
  }
}

@media (max-width: 991.98px) {
  .sentiment-header {
    background: none;

    span {
      display: inline;
    }
  }

  .kudos-header {
    background: none;

    span {
      display: inline;
    }
  }
}
</style>

<script>
// import CommunityInfo from "@/view/components/CommunityInfo.vue";
import {
  // GET_QUERY,
  API_CUSTOMERS,
  GET_PAGED
  // API_ORANGE_REPORTS,
  // API_ORANGE_REPORT_SERVICES,
  // // API_NINETY_DAY_PLAN,
  // POST_DATA
} from "@/core/store/crud.module";
// import crud from "@/core/helpers/crud";

// import { SET_BREADCRUMB } from "@/core/store/breadcrumbs.module";

// import dateFormatter from "@/core/helpers/dateFormatter";
import stringFormatter from "@/core/helpers/stringFormatter";

import { validationMixin } from "vuelidate";
// import dataModels from "@/core/helpers/datamodels.js";
import { required } from "vuelidate/lib/validators";
// import moment from "moment";
import permissionsHelper from "@/core/helpers/permissionsHelper";
// import draggable from "vuedraggable";
import translatedText from "@/core/helpers/translatedText.js";
import i18nService from "@/core/services/i18n.service.js";

export default {
  mixins: [validationMixin],
  components: {
    // CommunityInfo,
    // draggable
  },
  data: () => ({
    // communityInfo: {},
    // activeLang: "en",
    tt: {},
    // headers: [
    //   {
    //     value: "kudos",
    //     sortable: false,
    //     width: "40px",
    //     class: "kudos-header"
    //   },
    //   {
    //     value: "sentiment",
    //     sortable: false,
    //     width: "40px",
    //     class: "sentiment-header"
    //   },
    //   {
    //     text: "Community",
    //     value: "communityName"
    //   },
    //   {
    //     text: "Orange Report",
    //     value: "orangeReportActions",
    //     sortable: false
    //   },
    //   {
    //     text: "Service Requests",
    //     value: "serviceRequestsActions",
    //     sortable: false
    //   }
    // ],
    customers: [],
    quickFindCustomerId: 0,
    quickFindCustomers: [],
    totalCustomers: 10,
    customersQuery: "",
    options: {
      page: 1,
      itemsPerPage: 10,
      sortBy: ["openRequests", "communityName"],
      sortDesc: [true, false]
    },

    // orangeReport: {
    //   id: "",
    //   name: "",
    //   dateCreated: null,
    //   serviceDate: null,
    //   mowService: false,
    //   edgeService: false,
    //   hedgesService: false,
    //   irrigationService: false,
    //   plantingService: false,
    //   weedControlService: false,
    //   debrisRemovalService: false,
    //   repairsService: false,
    //   fertilizationService: false,
    //   visitNotes: "",
    //   photos: [],
    //   irrigationSystemInspectionDate: null,
    //   irrigationSystemHealth: "AllGoWithTheFlow",
    //   residentNotepad: "",
    //   ninetyDayPlanProgress: 0,
    //   ninetyDayPlanTrack: true,
    //   quarterlyOrangeWalkDate: null,
    //   followUpActions: ""
    // },
    pageText: "",
    hasMore: false,
    isLoading: false,
    isQuickFindCustomersLoading: false,
    loading: false,
    snackbarContent: "",
    snackbarColor: "#F06835",
    breadcrumbs: [],
    confirmDialog: false,

    permissions: {},
    requestProcessing: false,
    isMounted: false
  }),
  props: {
    // customerId: {
    //   type: [Number, String],
    //   default: 0
    // }
  },
  validations() {
    // return true;
    return {
      formattedServiceDate: {
        required
      },
      formattedQuarterlyOrangeWalkDate: {
        required
      }
    };
  },
  watch: {
    options: async function() {
      if (!this.isMounted) return;
      this.getCustomers();
    }
    // customerId: async function() {
    //   if (this.customerId && this.customerId != 0) {
    //     // await this.getComunityInfo();
    //     // await this.getNinetyDayPlan();
    //     // await this.getRecentOrangeReports();
    //   }
    // },
    // serviceDate: function() {
    //   this.formattedServiceDate = this.formatDate(this.serviceDate);
    // },
    // irrigationInspectionDate: function() {
    //   if (this.irrigationInspectionDate) {
    //     this.formattedIrrigationInspectionDate = this.formatDate(
    //       this.irrigationInspectionDate
    //     );
    //   }
    // },
    // quarterlyOrangeWalkDate: function() {
    //   this.formattedQuarterlyOrangeWalkDate = this.formatDate(
    //     this.quarterlyOrangeWalkDate
    //   );
    // }
  },
  async mounted() {
    this.isMounted = false;
    this.permissions = await permissionsHelper.getPermissions();
    // this.loading = true;
    // await this.getComunityInfo();
    // await this.createBreadcrumb();
    // await this.setInternalBreadcrumbs();
    // this.formattedServiceDate = this.formatDate(new Date());
    // this.loading = false;

    let self = this;
    self.loading = true;
    Promise.all([
      // this.getComunityInfo(),
      // this.getNinetyDayPlan(),

      await self.getQuickFindCustomers(),
      await self.getCustomers(),
      
    ]).then(function() {
      self.loading = false;
    });

    this.isMounted = true;

    // await this.getOrangeReportServices();
    // await this.getRecentOrangeReports();
  },
  async created() {
    this.tt = translatedText;
    // this.orangeReport = {
    //   id: "",
    //   name: "",
    //   dateCreated: null,
    //   serviceDate: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
    //     .toISOString()
    //     .substr(0, 10),
    //   formattedServiceDate: null,
    //   mowService: false,
    //   edgeService: false,
    //   hedgesService: false,
    //   irrigationService: false,
    //   plantingService: false,
    //   weedControlService: false,
    //   debrisRemovalService: false,
    //   repairsService: false,
    //   fertilizationService: false,
    //   visitNotes: "",
    //   photos: [],
    //   photosObj: [{ id: 1, url: null }],
    //   irrigationSystemInspectionDate: null,
    //   irrigationSystemHealth: "AllGoWithTheFlow",
    //   residentNotepad: "",
    //   ninetyDayPlanProgress: 0,
    //   ninetyDayPlanTrack: true,
    //   quarterlyOrangeWalkDate: null,
    //   followUpActions: "",
    //   renderedServices: []
    // };
    // this.serviceDate = new Date(
    //   Date.now() - new Date().getTimezoneOffset() * 60000
    // )
    //   .toISOString()
    //   .substr(0, 10);
    // this.formattedServiceDate = this.formatDate(this.serviceDate);
  },
  methods: {
    async getCustomers() {
      this.isLoading = true;
      let self = this;
      await this.$store
        .dispatch(GET_PAGED, {
          listName: API_CUSTOMERS,
          params: {
            customerStatus: "active",
            shortFormat: false,
            crewLeaderView: true
          }
        })
        .then(response => {
          let customers = [];
          if (response.status >= 200 || response.status <= 204) {
            let items = response.data.$values;
            customers = items;
          } else {
            self.$snackbar.showMessage({
              content: response.data || "Something went wrong!",
              color: "red"
            });
          }
          const { sortBy, sortDesc, page, itemsPerPage } = self.options;

          if (self.customerStatus && self.customerStatus !== "all") {
            let useIsActive = self.customerStatus === "active";

            customers = customers.filter(el => el.isActive === useIsActive);
          }

          if (self.viewByBranch && self.viewByBranch !== "all") {
            customers = customers.filter(
              el => el.branchName === self.viewByBranch
            );
          }

          const total = customers.length;

          let combinedRating = 0;
          let totalActive = 0;
          customers.forEach(element => {
            combinedRating += element.isActive ? element.sentiment.value : 0;
            totalActive += element.isActive ? 1 : 0;
          });

          if (totalActive !== 0) {
            combinedRating =
              Math.round((combinedRating * 10 * 1.0) / totalActive) / 10;
          }

          if (sortBy.length === 1 && sortDesc.length === 1) {
            customers = customers.sort((a, b) => {
              const sortA = a[sortBy[0]];
              const sortB = b[sortBy[0]];

              if (sortDesc[0]) {
                if (sortA < sortB) return 1;
                if (sortA > sortB) return -1;
                return 0;
              } else {
                if (sortA < sortB) return -1;
                if (sortA > sortB) return 1;
                return 0;
              }
            });
          }

          if (itemsPerPage > 0) {
            customers = customers.slice(
              (page - 1) * itemsPerPage,
              page * itemsPerPage
            );
          }

          {
            self.customers = customers;
            self.totalCustomers = total;
            self.rating = combinedRating;

            self.isCustomersLoading = false;
          }

          self.loading = false;
          self.isLoading = false;

          self.isLoading = false;
        });
    },

    async getQuickFindCustomers() {
      this.isQuickFindCustomersLoading = true;
      let self = this;
      await this.$store
        .dispatch(GET_PAGED, {
          listName: API_CUSTOMERS,
          params: {
            customerStatus: "active",
            shortFormat: true
          }
        })
        .then(response => {
          if (response.status >= 200 || response.status <= 204) {
            let items = response.data.$values;
            self.quickFindCustomers = items;
          } else {
            self.$snackbar.showMessage({
              content: response.data || "Something went wrong!",
              color: "red"
            });
          }

          self.isQuickFindCustomersLoading = false;
        });
    },
    // showRelatedCommunity(communityId) {
    //   this.$router.push({
    //     name: "CustomerDetails",
    //     params: { customerId: communityId }
    //   });
    // },
    // async getRelatedComunities() {
    //   this.relatedLoading = true;
    //   // this.communityInfo.relatedCommunitiesLoading = true;
    //   // this.$emit("onRelatedCommunityLoading");

    //   let self = this;
    //   await this.$store
    //     .dispatch(GET_QUERY, {
    //       listName: `${API_CUSTOMERS}/${self.communityInfo.aspireId}/relatedCustomers`
    //     })
    //     .then(response => {
    //       if (response.status >= 200 || response.status <= 204) {
    //         self.relatedCommunityItems = response.data;
    //         // self.communityInfo.relatedCommunities = self.relatedCommunityItems;
    //         // self.communityInfo.relatedCommunitiesLoading = false;
    //       }
    //       self.relatedLoading = false;
    //       // self.$emit("onRelatedCommunityLoaded", self.relatedCommunityItems);
    //     });
    // },
    // async getComunityInfo() {
    //   await this.$store
    //     .dispatch(GET_QUERY, {
    //       listName: API_CUSTOMERS,
    //       id: this.customerId
    //     })
    //     .then(response => {
    //       if (response.status >= 200 || response.status <= 204) {
    //         this.communityInfo = crud.getPopulatedComunityInfo(response.data);
    //         this.createBreadcrumb();
    //         this.setInternalBreadcrumbs();
    //       } else {
    //         this.$snackbar.showMessage({
    //           content: response.data || "Something went wrong!",
    //           color: "red"
    //         });
    //       }
    //     });
    // },
    // async getOrangeReportServices() {
    //   await this.$store
    //     .dispatch(GET_QUERY, {
    //       listName: API_ORANGE_REPORT_SERVICES
    //     })
    //     .then(response => {
    //       if (response.status >= 200 || response.status <= 204) {
    //         this.dbOrangeReportServices = response.data.$values;
    //       } else {
    //         this.$snackbar.showMessage({
    //           content: response.data || "Something went wrong!",
    //           color: "red"
    //         });
    //       }
    //     });
    // },
    // async getRecentOrangeReports() {
    //   let reportsUrl = `${API_CUSTOMERS}/${this.customerId}/orangeReports`;
    //   await this.$store
    //     .dispatch(GET_QUERY, {
    //       listName: reportsUrl
    //     })
    //     .then(response => {
    //       if (response.status >= 200 || response.status <= 204) {
    //         this.recentOrangeReports = response.data.$values;
    //         if (this.recentOrangeReports.length > 0) {
    //           let sortedOR = this.recentOrangeReports.slice().sort((a, b) => {
    //             return b.id - a.id;
    //           });

    //           let mostRecentOR = sortedOR[0];
    //           this.irrigationInspectionDate = null;
    //           if (mostRecentOR && mostRecentOR.irrigationInspectionDate) {
    //             this.irrigationInspectionDate = new Date(
    //               mostRecentOR.irrigationInspectionDate
    //             )
    //               .toISOString()
    //               .substr(0, 10);
    //           }
    //           if (mostRecentOR) {
    //             this.orangeReport.irrigationSystemHealth =
    //               mostRecentOR.irrigationSystemHealth;
    //           }
    //         }
    //       } else {
    //         this.$snackbar.showMessage({
    //           content: response.data || "Something went wrong!",
    //           color: "red"
    //         });
    //       }
    //     });
    // },
    // async getNinetyDayPlan() {
    //   await this.$store
    //     .dispatch(GET_QUERY, {
    //       listName: `${API_CUSTOMERS}/${this.customerId}/plans/current`
    //     })
    //     .then(response => {
    //       this.ninetyDayPlan = null;
    //       if (response.status >= 200 || response.status <= 204) {
    //         this.ninetyDayPlan = response.data;
    //         if (this.ninetyDayPlan) {
    //           this.ninetyDayPlanProgress = this.ninetyDayPlan.progress;

    //           this.quarterlyOrangeWalkDate = new Date(
    //             this.ninetyDayPlan.orangeWalkDate
    //           )
    //             .toISOString()
    //             .substr(0, 10);
    //           this.formattedQuarterlyOrangeWalkDate = this.formatDate(
    //             this.quarterlyOrangeWalkDate
    //           );
    //         }
    //       } else {
    //         this.$snackbar.showMessage({
    //           content: response.data || "Something went wrong!",
    //           color: "red"
    //         });
    //       }
    //     });
    // },
    // async setInternalBreadcrumbs() {
    //   this.breadcrumbs = [
    //     {
    //       title: this.communityInfo.name,
    //       route: "/customers/" + this.customerId
    //     },
    //     {
    //       title: "Orange Reports",
    //       route: "/customers/" + this.customerId + "/orange-reports"
    //     },
    //     { title: "New Orange Report" }
    //   ];
    // },
    // saveOrangeReportDialog() {
    //   this.confirmDialog = false;
    //   this.$router.push({
    //     name: "OrangeReports",
    //     params: { customerId: this.customerId }
    //   });
    // },
    // saveOrangeReport() {
    //   this.$v.$touch();
    //   if (this.$v.$invalid) {
    //     return;
    //   }

    //   this.orangeReport.id = this.communityInfo.recentOrangeReports.length;
    //   this.orangeReport.communityId = this.communityInfo.aspireId;
    //   // this.orangeReport.residentNotepad = this.orangeReport.residentNotepad;
    //   // this.orangeReport.followUpActions = this.orangeReport.followUpActions;
    //   this.orangeReport.irrigationSystemHealth = this.orangeReport.irrigationSystemHealth;
    //   if (this.irrigationInspectionDate) {
    //     this.orangeReport.irrigationInspectionDate = moment.utc(
    //       this.irrigationInspectionDate
    //     );
    //   }
    //   // this.orangeReport.dateCreated = Date.now();
    //   this.orangeReport.isApproved = false;
    //   this.orangeReport.serviceDate = moment.utc(this.serviceDate);
    //   if (this.irrigationInspectionDate) {
    //     this.orangeReport.irrigationSystemInspectionDate = moment.utc(
    //       this.irrigationInspectionDate
    //     );
    //   }
    //   if (this.ninetyDayPlan) {
    //     this.orangeReport.orangeWalkDate = moment.utc(
    //       this.quarterlyOrangeWalkDate
    //     );
    //   } else {
    //     this.orangeReport.orangeWalkDate = null;
    //   }

    //   if (this.ninetyDayPlan) {
    //     this.orangeReport.ninetyDayPlanProgress = Math.ceil(
    //       this.ninetyDayPlan.progress
    //     );
    //   } else {
    //     this.orangeReport.ninetyDayPlanProgress = 0;
    //   }
    //   if (this.ninetyDayPlan)
    //     this.orangeReport.ninetyDayPlanId = this.ninetyDayPlan.id;
    //   else this.orangeReport.ninetyDayPlanId = null;

    //   // this.orangeReport.name =
    //   //   "Orange Report - " + this.orangeReport.serviceDate;

    //   this.orangeReport.servicesRendered = [];
    //   for (let i = 0; i < this.dbOrangeReportServices.length; i++) {
    //     if (
    //       this.renderedServices.indexOf(this.dbOrangeReportServices[i].name) >
    //       -1
    //     )
    //       this.orangeReport.servicesRendered.push(
    //         this.dbOrangeReportServices[i]
    //       );
    //   }

    //   var self = this;
    //   this.orangeReport.photos = this.photosObj
    //     .filter(
    //       i =>
    //         i.url &&
    //         i.url.length > 0 &&
    //         !self.videoExtensions.includes(self.getExtensionFromUrl(i.url))
    //     )
    //     .map(i => {
    //       return { id: i.fileId, fileUrl: i.url };
    //     });
    //   this.orangeReport.photos = this.orangeReport.photos.filter(
    //     (item, index) => this.orangeReport.photos.indexOf(item) === index
    //   ); //remove duplicates

    //   this.communityInfo.orangeReports.push(this.orangeReport);

    //   this.requestProcessing = true;

    //   this.$store
    //     .dispatch(POST_DATA, {
    //       listName: `${API_ORANGE_REPORTS}`,
    //       data: this.orangeReport
    //     })
    //     .then(response => {
    //       if (response.status >= 200 && response.status <= 204) {
    //         self.snackbarContent =
    //           "Orange Report has been created successfully";
    //       } else {
    //         self.snackbarContent = response.data;
    //         self.snackbarColor = "red";

    //         self.$snackbar.showMessage({
    //           content: self.snackbarContent,
    //           color: self.snackbarColor
    //         });
    //       }

    //       self.confirmDialog = true;
    //       self.requestProcessing = false;
    //     });

    //   // this.saveCustomer();
    // },
    // onMultipleAddFile(files) {
    //   if (this.photosObj.length >= this.maxFilesCount) return;

    //   for (var i = 1; i < files.length; i++) {
    //     let max = Math.max(...this.photosObj.map(i => i.id));
    //     this.photosObj.push({
    //       id: (max += 1),
    //       url: files[i].fileUrl,
    //       fileId: files[i].id
    //     });

    //     if (this.photosObj.length === this.maxFilesCount) break;
    //   }

    //   if (this.photosObj.length < this.maxFilesCount) {
    //     let max = Math.max(...this.photosObj.map(i => i.id));
    //     this.photosObj.push({ id: (max += 1), url: null });
    //   }

    //   this.$nextTick(() => files.forEach(f => this.onChange(f)));
    // },
    // onChange(file) {
    //   if (file.fileUrl) {
    //     var found = this.photosObj.find(f => f.url == file.fileUrl);
    //     found.fileId = file.id;

    //     var extension = this.getExtensionFromUrl(file.fileUrl);
    //     var isVideo = this.videoExtensions.includes(extension);
    //     if (isVideo) {
    //       var videoInStore = 0;
    //       this.photosObj.forEach(obj => {
    //         var ext = this.getExtensionFromUrl(obj.url);
    //         var isVideo = this.videoExtensions.includes(ext);
    //         if (isVideo) videoInStore += 1;
    //       });
    //       if (videoInStore > 1) {
    //         let found = this.photosObj.find(f => f.url == file.fileUrl);
    //         let index = this.photosObj.indexOf(found);
    //         this.photosObj.splice(index, 1);
    //         this.saveResult.text = "You can add only one video";
    //         this.showModal = true;
    //       }
    //     }
    //   }
    // },
    // onDeleteFile(fileData) {
    //   // let initialPhotosCount = this.photosObj.length;
    //   let index = this.photosObj.findIndex(f => f.id === fileData.index);
    //   this.photosObj.splice(index, 1);

    //   if (this.photosObj.filter(el => !el.url).length == 0) {
    //     let max = Math.max(...this.photosObj.map(i => i.id));
    //     this.photosObj.push({ id: (max += 1), url: null });
    //   }
    // },
    // onDragCallBack(evt) {
    //   return (
    //     evt.draggedContext.element.url != null &&
    //     evt.relatedContext.element.url != null
    //   );
    // },
    // getExtensionFromUrl(url) {
    //   if (url) {
    //     var splited = url.split(".");
    //     return splited.length > 1 ? splited[splited.length - 1] : null;
    //   }
    //   return null;
    // },

    // createBreadcrumb() {
    //   this.$store.dispatch(SET_BREADCRUMB, [
    //     { title: "Customers", route: "/customers" },
    //     {
    //       title: this.communityInfo.name,
    //       route: "/customers/" + this.customerId
    //     },
    //     {
    //       title: "Orange Reports",
    //       route: "/customers/" + this.customerId + "/orange-reports"
    //     },
    //     { title: "New Orange Report" }
    //   ]);
    // },
    // async submit() {
    //   this.$v.$touch();
    //   if (this.$v.$invalid) {
    //     return;
    //   }
    // },
    getPermissions(permissionsObj) {
      this.permissions = permissionsObj;
    },
    capitalizeFirstLetter(string) {
      return stringFormatter.capitalizeFirstLetter(string);
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${month}/${day}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [month, day, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    }
  },
  computed: {
    activeLang() {
      return i18nService.getActiveLanguage();
    },
    headers() {
      return [
        {
          text: "Kudos",
          value: "kudos",
          sortable: false,
          width: "40px",
          class: "kudos-header"
        },
        {
          text: "Sentiment",
          value: "sentiment",
          sortable: false,
          width: "40px",
          class: "sentiment-header"
        },
        {
          text: this.tt[this.activeLang]["community"],
          value: "communityName"
        },
        {
          text: this.tt[this.activeLang]["orangeReport"],
          value: "orangeReportActions",
          sortable: false
        },
        {
          text: this.tt[this.activeLang]["serviceRequests"],
          value: "serviceRequestsActions",
          sortable: false
        }
      ];
    }
  }
};
</script>
